import { createTheme } from '@mui/material';

import defaultMuiThemeOptions from '../defaultMuiThemeOptions';
import { AppTheme, PaletteOptions, Theme } from '../types/AppTheme';

const palette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#bcd2ee',
    contrastText: '#000',
  },
  secondary: {
    main: '#6493cb',
    contrastText: '#fff',
  },
  background: {
    default: '#13206f',
    paper: '#fff',
  },
  text: {
    primary: '#fff',
  },
  error: {
    main: '#e85050',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#f67044',
    contrastText: '#ffffff',
  },
  success: {
    main: '#72d59c',
    contrastText: '#ffffff',
  },
  custom: {
    background: {
      contrastText: '#ffffff',
      dark: '#001f3e',
    },
    upgradeBlock: {
      background: '#00000044',
      contrastText: '#fff',
      arrow: '#00000066',
    },
    lightGray: '#eeeeee',
    gray: '#4D4F53',
    secondaryAccent: {
      altContrastText: '#bcd2ee',
      main: '#ffffff33',
      contrastText: '#fff',
    },
    input: {
      background: '#eeeeee',
      color: '#000',
    },
  },
};

const theme: AppTheme = {
  name: 'Midnight Blue',
  theme: createTheme({
    ...defaultMuiThemeOptions,
    palette,
  }) as Theme,
};

export default theme;
